import type { UseDataSourceResponsesType } from '@unifyapps/carbon/no-code/hooks/useDataSourceResponses';
import type { BaseFormBlockProps } from '../../../Form/types';

export function getIsDefaultValueDataSourceLoading({
  dataSourceResponses,
  dataSourceIds,
  defaultValue,
}: {
  dataSourceResponses: UseDataSourceResponsesType['dataSourceResponses'];
  dataSourceIds: BaseFormBlockProps['dataSourceIds'];
  defaultValue: unknown;
}) {
  return dataSourceIds?.some((dataSourceId) => {
    const dataSourceResponse = dataSourceResponses?.[dataSourceId];
    // if data is not present, that means the call to fetching data source is not done yet
    // in that case, we don't know when the data source will start to fetch, so we don't consider this value to be loading
    if (!dataSourceResponse?.data) return false;
    return (
      typeof defaultValue === 'string' &&
      defaultValue.includes(dataSourceId) &&
      Boolean(dataSourceResponse.data.isLoading)
    );
  });
}
